import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess } from '../../Actions/userActions';
import axios from 'axios';
import NavBar from '../../components/NavBar';
import image1 from '../../images/course2.jpg';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });

  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [disableResetButton, setDisableResetButton] = useState(false);
  const [showPassword, setShowPassword] = useState(false); 

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const isAdmin = user?.isAdmin;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post('https://gyanbackend.aim4u.co.in/login/', {
        email: formData.email,
        password: formData.password,
      });

      const { id, isadmin: backendIsAdmin, token } = data;
      const userData = { email: formData.email, id, isAdmin: backendIsAdmin };
      window.sessionStorage.setItem('accessToken', token.access);
      window.sessionStorage.setItem('user', JSON.stringify(userData));
      dispatch(loginSuccess({ email: formData.email, id, isAdmin: backendIsAdmin }));

      const successMessage = document.createElement('div');
      successMessage.className = 'toast-message success';
      successMessage.textContent = 'Login Successful! Welcome to Gyan AIM4u.';
      document.body.appendChild(successMessage);
      setTimeout(() => successMessage.remove(), 5000);

      // Redirect based on admin status after successful login
      if (backendIsAdmin) {
        navigate('/admin');
      } else {
        navigate('/');
      }
    } catch (error) {
      const errorMessage = document.createElement('div');
      errorMessage.className = 'toast-message error';
      errorMessage.textContent = 'Authentication failed. Please check your credentials.';
      document.body.appendChild(errorMessage);
      setTimeout(() => errorMessage.remove(), 5000);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    setOtpLoading(true);
    setDisableResetButton(true); 
    setCountdown(300);
    try {
      const response = await axios.post("https://gyanbackend.aim4u.co.in/request-password-reset/", {
        email: formData.email,
      });

      if (response.data.message === "Password reset link has been sent to your email.") {
        alert("Password reset link has been sent to your registered email.");
      } else {
        alert(response.data.message || "Email not registered.");
      }
    } catch (error) {
      alert("Error sending password reset link. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setDisableResetButton(false); 
    }
  }, [countdown]);

  return (
    <div className="login-container">
      {false && <NavBar name="Login" />}

      {false && (
        <div className="loading-overlay">
          <div className="loader"></div>
        </div>
      )}

      <div className="login-content">
        <div className="image-section">
          <img src={image1 || "/placeholder.svg"} alt="Login illustration" />
        </div>

        <div className="form-section">
          <div className="form-header">
            <h1>Welcome to <span className="highlight">Gyan@AiM4u</span></h1>
            <h2>Let's get you started</h2>
          </div>

          {!showForgotPassword ? (
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your Email Address"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="password-toggle-wrapper">
                  <input
                    type={showPassword ? 'text' : 'password'} 
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your Password"
                    required
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)} 
                  >
                    <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i> 
                  </button>
                </div>
              </div>

              <div className="form-group checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="rememberMe"
                    checked={formData.rememberMe}
                    onChange={handleChange}
                  />
                  <span>Remember me</span>
                </label>
              </div>

              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? 'Logging In...' : 'Login'}
              </button>

              <div className="form-footer">
                <p>Don't have an Account? <Link to="/register">Register</Link></p>
                <p className="forgot-password" onClick={() => setShowForgotPassword(true)}>
                  Forgot Password
                </p>
              </div>
            </form>
          ) : (
            <div className="forgot-password-section">
              <h3>Reset Your Password</h3>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your registered Email"
                  required
                />
                <button
                  className="otp-button"
                  onClick={handleForgotPassword}
                  disabled={disableResetButton || otpLoading}
                >
                  {otpLoading ? (
                    <span className="spinner"></span>
                  ) : countdown > 0 ? (
                    `Wait ${Math.floor(countdown / 60)}:${String(countdown % 60).padStart(2, "0")}`
                  ) : (
                    "Send Reset Link"
                  )}
                </button>
              </div>


              <button type="button" className="back-to-login" onClick={() => setShowForgotPassword(false)}>
                Back to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;